import AddDesignationForm from 'components/form/super-admin/master/designation/AddDesignationForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class AddDesignation extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Designation</h4>
                                <AddDesignationForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
